import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/_contexts/MenuContext.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/_providers/RootLayoutProvider.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/contexts/ProtectedContext.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-intl/dist/src/shared/NextIntlClientProvider.js");
import(/* webpackMode: "eager" */ "/vercel/path0/utils/nextInlHandlers.ts")